module.exports = __webpack_public_path__ + "static/teammaker-presentantion-fdbabb4b2c8e65de90190978b23935b8.gif";